export const parseJsonSafe = <T>(
    jsonString: string | undefined
): T | undefined => {
    if (!jsonString) {
        return undefined;
    }
    try {
        return JSON.parse(jsonString.replace(/'/g, '"')) as T;
    } catch {
        return undefined;
    }
};
